import React from 'react'
import loadScript from 'load-script'

let scriptLoadingStarted = false

const IMAGE_STORES_FOLDER_ID = '1TxrsOMs_hzNxI32OzNOvAyP31RCl4UHB'
const GOOGLE_SDK_URL = 'https://apis.google.com/js/api.js'
const CLIENT_ID =
  '899041326187-9js9hht6jff6ojujhrhv710ashme1cq1.apps.googleusercontent.com'
const DEVELOPER_KEY = 'AIzaSyDzvY7o-VLGJBxCctCAtSs8zxVHpzRiMxc'
const SCOPE = [
  'https://www.googleapis.com/auth/drive.readonly',
  // 'https://www.googleapis.com/auth/drive',
]

class GooglePickerImage extends React.Component {
  state = {
    file: null,
  }

  static defaultProps = {
    clientId: CLIENT_ID,
    scope: SCOPE,
  }

  componentDidMount() {
    if (this.isGoogleReady()) {
      // google api is already exists
      // init immediately
      this.onApiLoad()
    } else if (!scriptLoadingStarted) {
      // load google api and the init
      scriptLoadingStarted = true
      loadScript(GOOGLE_SDK_URL, this.onApiLoad)
    } else {
      // is loading
    }
  }

  isGoogleReady() {
    return !!window.gapi
  }

  isGoogleAuthReady() {
    return !!window.gapi.auth
  }

  isGooglePickerReady() {
    return !!window.google.picker
  }

  onApiLoad = () => {
    window.gapi.load('auth')
    window.gapi.load('picker')
  }

  doAuth = callback => {
    window.gapi.auth.authorize(
      {
        client_id: this.props.clientId,
        scope: this.props.scope,
        immediate: this.props.authImmediate,
      },
      callback,
    )
  }

  handleClick = () => {
    if (
      !this.isGoogleReady() ||
      !this.isGoogleAuthReady() ||
      !this.isGooglePickerReady() ||
      this.props.disabled
    ) {
      return null
    }

    const token = window.gapi.auth.getToken()
    const oauthToken = token && token.access_token

    if (oauthToken) {
      this.createPicker(oauthToken)
    } else {
      this.doAuth(response => {
        if (response.access_token) {
          this.createPicker(response.access_token)
        } else {
          this.handleAuthFail(response)
        }
      })
    }
  }

  handleAuthFailed = response => {
    console.error(response)
  }

  handlePickerChange = data => {
    console.info('handle picker change ', data)
    if (data.action === window.google.picker.Action.PICKED) {
      var fileId = data.docs[0].id
      this.loadFile(fileId)
    }
  }

  loadFile = async fileId => {
    const accessToken = window.gapi.auth.getToken().access_token
    console.log(fileId)
    console.log(accessToken)

    const file = {
      downloadUrl: `https://www.googleapis.com/drive/v2/files/${fileId}?alt=media`,
    }

    fetch(file.downloadUrl, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
      },
    })
      .then(res => {
        console.log(res)
        return res
      })
      .then(res => res.blob())
      .then(blob => {
        console.log(blob)
        return new File([blob], 'test', { type: blob.type })
      })
      .then(imageFile => {
        this.props.onImagePicked(imageFile)
      })
  }

  createPicker = oauthToken => {
    const parentID = IMAGE_STORES_FOLDER_ID
    const google = window.google
    // const view = new google.picker.View(google.picker.ViewId.DOCS)
    //   .setMimeTypes('image/png,image/jpeg,image/jpg')
    //   .setQuery('screen')
    var docsView = new google.picker.DocsView()
      .setParent(parentID)
      .setIncludeFolders(true)
      .setSelectFolderEnabled(true)
    const picker = new google.picker.PickerBuilder()
      .setLocale('th')
      .setOAuthToken(oauthToken)
      .setDeveloperKey(DEVELOPER_KEY)
      .setCallback(this.handlePickerChange)
      .enableFeature(google.picker.Feature.NAV_HIDDEN)
      // .enableFeature(google.picker.Feature.SIMPLE_UPLOAD_ENABLED)
      // .enableFeature(google.picker.Feature.MULTISELECT_ENABLED)
      .addView(docsView)
      .addView(
        new google.picker.DocsUploadView()
          .setIncludeFolders(true)
          .setParent(parentID),
      )
      .addView(google.picker.ViewId.IMAGE_SEARCH)

    picker.build().setVisible(true)
  }

  render() {
    if (this.props.children) {
      return this.props.children({ onClick: this.handleClick })
    } else {
      return (
        <button className="button is-primary" onClick={this.handleClick}>
          <div className="icon">
            <i className="fab fa-google-drive" />
          </div>
          <span>Goole Drive</span>
        </button>
      )
    }
  }
}

export default GooglePickerImage



// WEBPACK FOOTER //
// ./src/modules/google-picker/GooglePickerImage.js